module.exports = __webpack_public_path__ + "assets/static/media/img_error.5c76f858.png";